import type { Compte } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

const getComptesTiers = () =>
	request.get<unknown, TemplateRequestGet<Compte>>(
		'/api/finances/comptabilite/tiers/comptes?all',
	);

export default getComptesTiers;
